export enum RouterPaths {
  SEARCH = 'search',
  TOKENS = 'tokens',
}
